import SyosController from './SyosController';

window.tnew.syos = {
  SyosController,
};
